import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public loaderImageShow: boolean = false;
  public loaderMessage: string = 'Loading...';
  private loaderId!: HTMLElement;
    toastRef: any;
  constructor(private toaster: ToastrService) {

  }

  showLoader = (message: string = 'Loading...'): void => {
    if (!this.loaderId) {
      const loader = document.getElementById('loader');
      if (loader) {
        this.loaderId = loader;
      } else {
        return;
      }
    }
    this.loaderId.style.display = 'block';
    this.loaderImageShow = true;
    this.loaderMessage = message;
    setTimeout(() => {
      this.loaderImageShow = true;
    }, 10);
  };

  hideLoader = (): void => {
    if (!this.loaderId) return;
    this.loaderId.style.display = 'none';

    setTimeout(() => {
      this.loaderImageShow = false;
    }, 100);
  };

  showProcessingToaster(msg: string = 'Processing request...', subMeg:string= 'Please wait') {
     this.toastRef = this.toaster.info(msg, subMeg, {
      disableTimeOut: true,
      closeButton: false,
      progressBar: true,
      positionClass: 'toast-top-right' 
    });
  }

  hideProcessingToaster() {
    if (this.toastRef) {
      this.toaster.remove(this.toastRef.toastId);
    }
  }


}
